import { Countdown } from '../components/Countdown';
import { Schedule } from '../components/Schedule';
import { Screen } from '../components/Screen';
import { VideoHero } from '../components/VideoHero';

// Saturday, 3 October 2026 — Kuala Lumpur (time TBC).
const WEDDING_DATE = new Date('2026-10-03T17:00:00+08:00');

export function Overview() {
  return (
    <>
      {/* Cinematic cover: the couple video opens the page, names + date over the fade. */}
      <VideoHero src="/video/couple-video-01.mp4">
        <p className="eyebrow">Together with their families</p>
        <h1 className="serif" style={{ fontSize: '3rem', fontWeight: 500, margin: '6px 0 0' }}>
          Lynne &amp; Andi
        </h1>
        <p className="eyebrow" style={{ marginTop: 8 }}>
          03 · 10 · 2026
        </p>
      </VideoHero>

      <Screen>
        <Countdown target={WEDDING_DATE} />

        <p
          style={{ color: 'var(--text-dim)', lineHeight: 1.6, textAlign: 'center', marginTop: 30 }}
        >
          We&apos;re getting married — and we&apos;d love for you to be there. Meet the two of us,
          and let us know you&apos;re coming.
        </p>

        {/* Tappable venue card — opens the shareable map location in a new tab. */}
        <a
          href="https://share.google/w8nDUeVPAZqmlRazz"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'block',
            marginTop: 28,
            padding: '20px 18px',
            border: '1px solid var(--border)',
            borderRadius: 'var(--radius)',
            background: 'var(--surface)',
            textAlign: 'center',
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          <p className="serif" style={{ fontSize: '1.5rem', margin: 0 }}>
            The Estate on Federal Hill
          </p>
          <p style={{ color: 'var(--text-dim)', fontSize: 14, margin: '8px 0 0' }}>
            Saturday, 3 October 2026
          </p>
          <p className="eyebrow" style={{ marginTop: 4 }}>
            Kuala Lumpur, Malaysia
          </p>
          <span
            style={{
              display: 'inline-block',
              marginTop: 14,
              color: 'var(--gold)',
              fontSize: 12.5,
              letterSpacing: '0.04em',
            }}
          >
            View location ↗
          </span>
        </a>

        <Schedule />
      </Screen>
    </>
  );
}
